// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"9d28438d","418":"9935cdb0","480":"3798b159","638":"d54f8a44","854":"03bb82ff"}[chunkId] + ".chunk.js";
};